import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UsersConfirmState {
  popupIsOpen: boolean;
  isLoading: boolean;
}

const initialState: UsersConfirmState = {
  popupIsOpen: false,
  isLoading: false,
};

export const usersConfirmSlice = createSlice({
  name: 'usersConfirm',
  initialState,
  reducers: {
    handleConfirmPopup: (state, action: PayloadAction<boolean>) => {
      state.popupIsOpen = action.payload;
    },
    resetConfirmState: (state) => {
      state.popupIsOpen = initialState.popupIsOpen;
      state.isLoading = initialState.isLoading;
    },
  },
});

export const {
  handleConfirmPopup,
  resetConfirmState,
} = usersConfirmSlice.actions;

export default usersConfirmSlice.reducer;
